import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * FILA DE ESPERA / PRÉ-MATRÍCULA — as três telas que atendem as inscrições do portal de
 * pré-matrícula (docs/fila-espera-prematricula/README.md).
 *
 * Permissões PRÓPRIAS, vizinhas das legadas (300200500 / 300200600 / 300200700). O `name` de
 * cada rota é o que a Seg_Menu grava na coluna `name` (script
 * consultebase/scripts/2026-09-30-Permissoes-FilasPreMatricula.sql).
 */
export default [
  {
    description: 'Consulta Espera de Matrículas',
    path: '/academico/consulta-espera-matriculas',
    name: 'consulta_espera_matriculas',
    component: () => import('@/views/academico/filaespera/consulta/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.CONSULTAESPERADEMATRICULASNOVO_MENU_300200599],
    },
    goesToMenu: true,
  },
  {
    description: 'Recebimento de Pré-Matrículas',
    path: '/academico/recebimento-prematriculas',
    name: 'recebimento_prematriculas',
    component: () => import('@/views/academico/filaespera/recebimento/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.RECEBIMENTODEPREMATRICULASNOVO_MENU_300200699],
    },
    goesToMenu: true,
  },
  {
    description: 'Recebimento de Pré-Matrículas Pró-Jovem',
    path: '/academico/recebimento-prematriculas-projovem',
    name: 'recebimento_prematriculas_projovem',
    component: () => import('@/views/academico/filaespera/projovem/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.RECEBIMENTODEPREMATRICULASPROJOVEMNOVO_MENU_300200799],
    },
    goesToMenu: true,
  },
];
